import { useEffect, useState } from "react";
import { getAttendanceReport } from "../../services/attendanceService";
import AttendanceStats from "./AttendanceStats";
import AttendanceTable from "./AttendanceTable";
import AttendanceFilters from "./AttendanceFilters";
import { useUser } from "../../context/AuthContext";
import "./Attendance.css";

const Attendance = () => {
    const [attendance, setAttendance] = useState([]);
    const { user, loading } = useUser();

    const getToday = () => new Date().toISOString().split("T")[0];

    const getYesterday = () => {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d.toISOString().split("T")[0];
    };

    const [filters, setFilters] = useState({
        GroupId: "",
        BranchId: "",
        CourseId: "",
        FromDate: getYesterday(),
        ToDate: getToday(),
    });

    const loadAttendance = async () => {
        try {
            const payload = {
                GroupId: filters.GroupId,
                BranchId: filters.BranchId,
                CourseId: filters.CourseId,
                FromDate: filters.FromDate,
                ToDate: filters.ToDate,
            };

            console.log("Payload 👉", payload);

            const res = await getAttendanceReport(payload);

            console.log("Response ✅", res);
            console.log("Records count 👉", res?.length);

            // ✅ STORE ARRAY DIRECTLY
            setAttendance(res || []);
        } catch (err) {
            console.error("Attendance Error ❌", err?.response || err);
            setAttendance([]);
        }
    };


    // ✅ OPTIONAL: Auto-load when required filters are ready
    useEffect(() => {
        if (filters.GroupId && filters.BranchId && filters.CourseId) {
            loadAttendance();
        }
    }, [filters.GroupId, filters.BranchId, filters.CourseId]);

    if (loading) return <div>Loading attendance...</div>;

    return (
        <div className="attendance-page">
            <AttendanceFilters
                userData={user}
                filters={filters}
                onChange={setFilters}
                onApply={loadAttendance}
            />

            <AttendanceStats data={attendance} />

            <AttendanceTable data={attendance} />
        </div>
    );
};

export default Attendance;
